/**
 * Replace path strings with your backend routes (single place to edit).
 * `requestReset` + `confirmReset` are treated as public (no JWT) in `api.ts`.
 */
export const PASSWORD_API_PATHS = {
  requestReset: '/auth/forgot-password',
  verifyOtp: '/auth/verify-otp',
  confirmReset: '/auth/reset-password',
  change: '/password/change',
} as const

export const PASSWORD_PUBLIC_PATHS: readonly string[] = [
  PASSWORD_API_PATHS.requestReset,
  PASSWORD_API_PATHS.verifyOtp,
  PASSWORD_API_PATHS.confirmReset,
]
